import { ContentLayout } from '@/bundle/Layouts/ContentLayout/ContentLayout';
import { PageBody } from '@/components/Page/PageBody/PageBody';
import { Box } from '@/components/Box/Box';
import { Tabs } from '@/components/Tabs/Tabs';
import { Tab } from '@/components/Tabs/ui/Tab/Tab';
import { useGetSearchParams } from '@/hooks/useGetSearchParams';
import { useReplaceSearchParams } from '@/hooks/useReplaceSearchParams';
import { useSubscriptionStatus } from '@/bundle/shared/hooks/useSubscriptionStatus';
import { OrganizationSubscriptionStatusBanner } from '@/bundle/shared/components/banner/OrganizationSubscriptionStatusBanner/OrganizationSubscriptionStatusBanner';
import { INVOICE_VAULT_TABS, InvoiceVaultTabType } from './const/const';
import { CheckInvoiceTab } from './ui/CheckInvoiceTab/CheckInvoiceTab';
import { LinkAndQrTab } from './ui/LinkAndQrTab/LinkAndQrTab';
import { IntegrationsTab } from './ui/IntegrationsTab/IntegrationsTab';
import { OpenApiTab } from './ui/OpenApiTab/OpenApiTab';

type ParamsType = { tab?: InvoiceVaultTabType };

export const InvoiceVaultPage = () => {
  const searchParams = useGetSearchParams<ParamsType>();
  const { replaceSearchParams } = useReplaceSearchParams<ParamsType>();
  const { isInactiveSubscription } = useSubscriptionStatus();

  const tab: InvoiceVaultTabType = searchParams.tab ?? 'check';
  const isCheckInvoiceTab = tab === 'check';

  return (
    <ContentLayout
      title='Invoice Vault'
      breadcrumbs='Invoice Vault'
      subtitle='Check a vendor invoice before you pay it, put a verified payment link on your own invoices, or connect your invoicing platform.'
      banner={isInactiveSubscription && <OrganizationSubscriptionStatusBanner />}
    >
      <PageBody>
        <Box marginBottom='24px'>
          <Tabs onChange={(value) => replaceSearchParams({ tab: value as InvoiceVaultTabType })}>
            {INVOICE_VAULT_TABS.map(({ value, label, disabled }) => (
              <Tab key={value} value={value} isActive={tab === value} disabled={disabled}>
                {label}
              </Tab>
            ))}
          </Tabs>
        </Box>
        {isCheckInvoiceTab && <CheckInvoiceTab />}
        {tab === 'link' && <LinkAndQrTab />}
        {tab === 'integrations' && <IntegrationsTab />}
        {tab === 'api' && <OpenApiTab />}
      </PageBody>
    </ContentLayout>
  );
};
